<!-- <span class="col-form-label">{{ label }}</span> -->
<label class="col-form-label" [for]="name">{{ label }}</label>
<label class="switch switch-lg switch-success" [formGroup]="form">
  <input type="checkbox" class="switch-input form-control" checked [name]="name" [formControlName]="controlName">
  <span class="switch-slider"></span>
</label>
